import { createSelector } from 'reselect';
import { getGatesFromAuth } from '../selectors/AuthSelector';
const MULTI_EMAIL_GATE = 'Identity:MultiEmail';
export const getHasMultiEmailAccess = createSelector([getGatesFromAuth], gates => gates.indexOf(MULTI_EMAIL_GATE) > -1);